export default __webpack_public_path__ + "static/media/Digital_3_Pin_Input@2x.9c3e2f66.png";